// This function allow to reference chunks
__webpack_require__.miniCssF = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"494": "4077578422d4","8561": "f9cad78a6d35","9096": "c01d7e7f2245",}[chunkId] + ".css"
}